import { Block, BlockSchema } from './Block.types';

import { BlockType, EmbedBlockConfigSchema } from './blockConfig/Types';

import { z } from 'zod';

export const EmbedBlockSchema = BlockSchema.extend({
  blockConfig: EmbedBlockConfigSchema,
});
export type EmbedBlock = z.infer<typeof EmbedBlockSchema>;

export function isEmbedBlock(block: Block): block is EmbedBlock {
  return block.blockConfig.type === BlockType.Embed;
}
